<template>
  <div class="smartTowm">
    <div class="modular">
      <div class="title">
        <!-- <div class="text">
          智慧数字乡村建设，利用现代信息与互联网技术，构建<span>以网络通信为基础,村大数据为支撑</span>的数据处理中心；构筑<span>智慧管理、智慧服务、智慧决策</span>三大应用体系，共建共享、互融互通的数字乡村框架体系，切实提升村级信息化水平。为乡村实现精细化管理、个性化服务奠定坚实基础，完成<span>信息化体系</span>初步建设，预留拓展空间。通过数字化建设<span>提高农村地区治安管理水平</span>，推广使用各类个体感知、环境监测农业物联网设备。建设<span>智能农业生产决策控制</span>体系，结合乡村旅游发展大趋势，发挥数字乡村的引领作用，整合周边资源，实现乡村可持续发展。
        </div> -->
        <div class="name">智慧城镇</div>
        <div class="text">通过实时数据管控，实现管理和服务的双提升</div>
      </div>
      <ul class="ul">
        <li class="li" v-for="(item, index) in list" :key="index">
          <div class="icon">
            <img :src="item.imgUrl" alt="" />
          </div>
          <div class="text">
            <div class="top">{{ item.title }}</div>
            <div class="bottom">{{ item.text }}</div>
          </div>
        </li>
      </ul>
      <!-- <div class="img">
        <img src="../img/village.png" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'smartTowm',
  data() {
    return {
      list: [
        { imgUrl: require('../img/masonry.png'), title: '数据驾驶舱', text: '通过数据驾驶舱，进行综合管控，汇聚N个智慧应用，进行分析研判' },
        { imgUrl: require('../img/masonry.png'), title: '综合管理平台', text: '基于GIS对城镇基础设施设备、环境保护、公共交通等各领域进行一张图综合管理展示' },
        { imgUrl: require('../img/masonry.png'), title: '智慧应用', text: '汇聚智慧安防、智慧交通、智慧农业、智慧消防、环境监测等诸多应用' }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.smartTowm {
  position: relative;
  background: #efeff4;

  .modular {
    width: 100%;
    max-width: 100%;
    min-height: 1055px;
    background: #efeff4;
    overflow: hidden;
    margin: 0 auto;
    padding: 110px clamp(24px, 8vw, 180px) 120px;
    box-sizing: border-box;

    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 0 clamp(12px, 6vw, 220px);

      .name {
        font-weight: 600;
        font-size: clamp(28px, 2.4vw, 40px);
      }

      .text {
        margin-top: 30px;
        font-size: clamp(18px, 1.8vw, 28px);
        font-family: 'PingFang';
        font-weight: 600;
        color: #252525;
      }
    }

    .ul {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 40px 56px;
      margin-top: 77px;

      .li {
        display: flex;
        align-items: flex-start;
        min-height: 250px;

        .icon {
          margin-top: 10px;
          margin-right: 30px;

          img {
            width: clamp(56px, 4.6vw, 80px);
            height: auto;
          }
        }

        .text {
          .top {
            font-size: clamp(22px, 1.8vw, 30px);
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 550;
            color: #252525;
          }

          .bottom {
            margin-top: 20px;
            font-size: clamp(16px, 1.3vw, 22px);
            letter-spacing: 2px;
            line-height: 1.7;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #252525;
          }
        }
      }
    }
    .img {
      position: absolute;
      top: 630px;
      left: 780px;
      width: 345px;
      height: 345px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media (max-width: 1200px) {
  .smartTowm .modular .ul {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .smartTowm .modular {
    padding: 72px 20px 80px;
  }

  .smartTowm .modular .title {
    padding: 0;
  }

  .smartTowm .modular .title .text {
    margin-top: 18px;
    line-height: 1.6;
  }

  .smartTowm .modular .ul {
    grid-template-columns: 1fr;
    gap: 28px;
    margin-top: 48px;
  }

  .smartTowm .modular .ul .li {
    min-height: auto;
  }

  .smartTowm .modular .ul .li .icon {
    margin-right: 18px;
  }
}
</style>
